import Icon, { type IconName } from './Icon';

interface FeatureCardProps {
  icon: IconName;
  title: string;
  description: string;
  index?: string;
}

export default function FeatureCard({ icon, title, description, index }: FeatureCardProps) {
  return (
    <div className="group flex flex-col border-t border-ink/15 pt-6">
      <div className="flex items-center justify-between">
        {index && <span className="index-num">{index}</span>}
        <Icon name={icon} className="h-6 w-6 text-primary/70" />
      </div>
      <h3 className="mt-5 text-lg font-semibold text-text-primary">{title}</h3>
      <p className="mt-2 text-sm leading-6 text-text-secondary">{description}</p>
    </div>
  );
}
